export interface LogoProps {
  size: number;
  className?: string;
}

export default function StaticLogo({ size, className }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 282 282"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M80.0827 34.974C92.7457 3.8081 120.792 17.7546 134.476 29.5676C135.325 30.301 135.792 31.3761 135.792 32.4985V250.806C135.792 251.98 135.258 253.117 134.349 253.858C103.339 279.155 85.2835 259.158 80.0827 245.771C44.9187 241.11 43.965 209.932 47.8837 194.925C15.173 187.722 17.5591 152.731 22.841 136.135C9.34813 107.747 33.9141 90.4097 47.8837 85.2899C40.524 50.5456 66.2831 37.2692 80.0827 34.974Z"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="95.4357"
        y2="-2.5"
        transform="matrix(0.591888 0.80602 -0.783494 0.6214 77.3574 37.2551)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <path
        d="M49.1309 84.7972L136.212 176.505"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="90.8224"
        y2="-2.5"
        transform="matrix(0.814972 0.5795 -0.549892 0.835235 32.5566 143.53)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="146.141"
        y2="-2.5"
        transform="matrix(0.686415 -0.72721 0.700262 0.713886 35.4785 139.482)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="77.4689"
        y2="-2.5"
        transform="matrix(0.528012 -0.849237 0.830187 0.557485 49.1133 196.162)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="111.328"
        y2="-2.5"
        transform="matrix(-0.979793 0.200014 -0.185721 -0.982602 135.791 117.215)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="58.5744"
        y2="-2.5"
        transform="matrix(0.532065 -0.846704 0.827428 0.561572 81.252 246.769)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="64.5426"
        y2="-2.5"
        transform="matrix(-0.503861 -0.863784 0.846088 -0.533044 137.443 252.884)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="45.7129"
        y2="-2.5"
        transform="matrix(-0.0852204 0.996362 -0.99576 -0.0919863 110.471 150.615)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="87.7453"
        y2="-2.5"
        transform="matrix(0.998935 -0.0461398 0.0427267 0.999087 49.1133 198.186)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="64.6589"
        y2="-2.5"
        transform="matrix(-0.165686 0.986178 -0.983932 -0.178541 100.73 66.6073)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <circle cx="103.955" cy="66.3968" r="11.0444" fill="#C15E50" />
      <circle cx="90.4996" cy="129.403" r="11.5465" fill="#C15E50" />
      <circle cx="103.955" cy="197.449" r="11.0444" fill="#C15E50" />
      <circle cx="48.4992" cy="86.0547" r="8.53434" fill="#C15E50" />
      <path
        d="M86.0294 34.6113C86.0294 38.7701 82.6579 42.1416 78.4991 42.1416C74.3402 42.1416 70.9688 38.7701 70.9688 34.6113C70.9688 30.4524 74.3402 27.081 78.4991 27.081C82.6579 27.081 86.0294 30.4524 86.0294 34.6113Z"
        fill="#C15E50"
      />
      <circle cx="29.0525" cy="140.996" r="13.0525" fill="#C15E50" />
      <circle cx="79.0009" cy="246.875" r="7.02828" fill="#C15E50" />
      <path
        d="M53.0314 195.433C53.0314 199.869 49.4352 203.466 44.9991 203.466C40.563 203.466 36.9668 199.869 36.9668 195.433C36.9668 190.997 40.563 187.401 44.9991 187.401C49.4352 187.401 53.0314 190.997 53.0314 195.433Z"
        fill="#C15E50"
      />
      <path
        d="M202.806 247.026C190.143 278.192 162.097 264.245 148.413 252.432C147.563 251.699 147.097 250.624 147.097 249.501V31.1935C147.097 30.0203 147.631 28.8833 148.54 28.1417C179.549 2.84476 197.605 22.8418 202.806 36.2294C237.97 40.8903 238.924 72.0684 235.005 87.0748C267.716 94.2779 265.33 129.269 260.048 145.865C273.541 174.253 248.975 191.59 235.005 196.71C242.365 231.454 216.606 244.731 202.806 247.026Z"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="95.4357"
        y2="-2.5"
        transform="matrix(-0.591888 -0.80602 0.783494 -0.6214 205.531 244.745)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <path
        d="M233.758 197.203L146.677 105.495"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="90.8224"
        y2="-2.5"
        transform="matrix(-0.814972 -0.5795 0.549892 -0.835235 250.332 138.47)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="146.141"
        y2="-2.5"
        transform="matrix(-0.686415 0.72721 -0.700262 -0.713886 247.41 142.518)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="77.4689"
        y2="-2.5"
        transform="matrix(-0.528012 0.849237 -0.830187 -0.557485 233.775 85.838)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="111.328"
        y2="-2.5"
        transform="matrix(0.979793 -0.200014 0.185721 0.982602 147.098 164.785)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="58.5744"
        y2="-2.5"
        transform="matrix(-0.532065 0.846704 -0.827428 -0.561572 201.637 35.2307)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="64.5426"
        y2="-2.5"
        transform="matrix(0.503861 0.863784 -0.846088 0.533044 145.445 29.1161)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="45.7129"
        y2="-2.5"
        transform="matrix(0.0852204 -0.996362 0.99576 0.0919863 172.418 131.385)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="87.7453"
        y2="-2.5"
        transform="matrix(-0.998935 0.0461398 -0.0427267 -0.999087 233.775 83.8137)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <line
        y1="-2.5"
        x2="64.6589"
        y2="-2.5"
        transform="matrix(0.165686 -0.986178 0.983932 0.178541 182.158 215.393)"
        stroke="#C15E50"
        strokeWidth="5"
      />
      <circle
        cx="178.934"
        cy="215.603"
        r="11.0444"
        transform="rotate(180 178.934 215.603)"
        fill="#C15E50"
      />
      <circle
        cx="192.389"
        cy="152.597"
        r="11.5465"
        transform="rotate(180 192.389 152.597)"
        fill="#C15E50"
      />
      <circle
        cx="178.934"
        cy="84.5506"
        r="11.0444"
        transform="rotate(180 178.934 84.5506)"
        fill="#C15E50"
      />
      <circle
        cx="234.389"
        cy="195.945"
        r="8.53434"
        transform="rotate(180 234.389 195.945)"
        fill="#C15E50"
      />
      <path
        d="M196.859 247.389C196.859 243.23 200.231 239.858 204.39 239.858C208.548 239.858 211.92 243.23 211.92 247.389C211.92 251.548 208.548 254.919 204.39 254.919C200.231 254.919 196.859 251.548 196.859 247.389Z"
        fill="#C15E50"
      />
      <circle
        cx="253.836"
        cy="141.004"
        r="13.0525"
        transform="rotate(180 253.836 141.004)"
        fill="#C15E50"
      />
      <circle
        cx="203.888"
        cy="35.1255"
        r="7.02828"
        transform="rotate(180 203.888 35.1255)"
        fill="#C15E50"
      />
      <path
        d="M229.857 86.5668C229.857 82.1307 233.453 78.5345 237.89 78.5345C242.326 78.5345 245.922 82.1307 245.922 86.5668C245.922 91.0029 242.326 94.5991 237.89 94.5991C233.453 94.5991 229.857 91.0029 229.857 86.5668Z"
        fill="#C15E50"
      />
    </svg>
  );
}
